'use client';

import { c as _c } from "react/compiler-runtime";
import { Button } from '@algoacademy/design-system/web/actions/Button';
import { IllustrationOnTheLeftLayout } from '@algoacademy/design-system/web/layouts/IllustrationOnTheLeftLayout';
import { VerticalSpacer } from '@algoacademy/design-system/web/layouts/VerticalSpacer';
import { H2 } from '@algoacademy/design-system/web/marketing/typography/Heading';
import { P2 } from '@algoacademy/design-system/web/marketing/typography/Paragraph';
import { useState } from 'react';
import { EbookPopup } from '../_components/EbookPopup';
import ManReadingAnArticle from '../_svg/ManReadingAnArticle';
export function EbookSection() {
  const $ = _c(9);
  const [isEbookOpen, setEbookOpen] = useState(false);
  let t0;
  let t1;
  let t2;
  let t3;
  let t4;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <ManReadingAnArticle />;
    t1 = <H2>Darmowy e-book „Nasza metoda nauczania”</H2>;
    t2 = <VerticalSpacer size="content" />;
    t3 = <P2>Chcesz poznać naszą metodę szczegółowo? Pobierz bezpłatny e-book i dowiedz się więcej.</P2>;
    t4 = <VerticalSpacer size="content" />;
    $[0] = t0;
    $[1] = t1;
    $[2] = t2;
    $[3] = t3;
    $[4] = t4;
  } else {
    t0 = $[0];
    t1 = $[1];
    t2 = $[2];
    t3 = $[3];
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <IllustrationOnTheLeftLayout illustration={t0}>{t1}{t2}{t3}{t4}<Button size="xl" onClick={() => setEbookOpen(true)} className="w-full lg:w-fit">Pobierz e-book</Button></IllustrationOnTheLeftLayout>;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = () => setEbookOpen(false);
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== isEbookOpen) {
    t7 = <>{t5}<EbookPopup open={isEbookOpen} onClose={t6} /></>;
    $[7] = isEbookOpen;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  return t7;
}